// extracted by mini-css-extract-plugin
module.exports = {"mainControlContainer":"Main_mainControlContainer__2IfMX","mainContainer":"Main_mainContainer__1UqJk"};